<script setup lang="ts">
import { CtIcon } from '@camelot/components'
import BreadcrumbButton from '~/components/header/BreadcrumbButton.vue'
import { useStepStore } from '~/stores/step'
import { type StepPath, STEPS_RECORD } from '~/stores/steps-definition'

const props = defineProps<{
  name: StepPath
}>()

const store = useStepStore()

function getChevronColor(stepPath: StepPath) {
  return store.stepsStarted[stepPath] ? '--ct-color-pitch' : '--ct-color-black-40'
}
</script>

<template>
  <div class="snap-center shrink-0">
    <BreadcrumbButton :name="props.name" />
    <CtIcon v-if="name !== 'personal'" size="28" name="chevron_right_sm" :color="getChevronColor(STEPS_RECORD[props.name].next!.path)" />
  </div>
</template>
